import { CartProvider } from './components/hooks/useCart';
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Eagerly load the entry point — every user sees this first
import WelcomePage from './components/WelcomePage';

// Analytics + support widgets live outside <Suspense> so they are never
// unmounted while a lazy route chunk is loading.
import AnalyticsTracker from './components/AnalyticsTracker';
import WhatsAppFloat from './components/WhatsAppFloat';

// Lazy-load everything else so the initial JS bundle is minimal
const GameSelection       = lazy(() => import('./components/GameSelection'));
const GoKartPromoSelection = lazy(() => import('./components/GoKartPromoSelection'));
const Checkout            = lazy(() => import('./components/checkout'));
const Queue               = lazy(() => import('./components/Queue'));
const Ticket              = lazy(() => import('./components/Ticket'));
const CartAndPayment      = lazy(() => import('./components/CartAndPayment'));
const UserDetails         = lazy(() => import('./components/UserDetails'));
const PaystackPaymentPage = lazy(() => import('./components/PaystackPaymentPage'));

const PageLoader: React.FC = () => (
  <div style={{
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '100vh', background: '#0f172a', color: '#d4f5ec',
    fontSize: '1rem', fontFamily: 'system-ui, sans-serif',
  }}>
    Loading…
  </div>
);

const App: React.FC = () => {
  return (
    <CartProvider>
      <Router>
        <AnalyticsTracker />
        <WhatsAppFloat />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/GameSelection" element={<GameSelection />} />
            <Route path="/gokart" element={<GoKartPromoSelection />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/UserDetails" element={
              <UserDetails userDetails={{ username: '', phone: '' }} setUserDetails={() => {}} onNext={() => {}} />
            } />
            <Route path="/CartAndPayment" element={
              <CartAndPayment cartItems={[]} cartTotal={0} payment_methods={[]} setPaymentMethods={() => {}} setCartItems={() => {}} onNext={() => {}} />
            } />
            <Route path="/Queue" element={<Queue />} />
            <Route path="/Ticket" element={<Ticket />} />
            <Route path="/PaystackPaymentPage" element={
              <PaystackPaymentPage standalone cartTotal={0} userDetails={{ username: '', phone: '' }} cartItems={[]} />
            } />
          </Routes>
        </Suspense>
      </Router>
    </CartProvider>
  );
};

export default App;
